import { render, staticRenderFns } from "./TestReturnList.vue?vue&type=template&id=09d9646c&"
import script from "./TestReturnList.vue?vue&type=script&lang=js&"
export * from "./TestReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports